import { Component, OnInit, Input } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmRedeemComponent } from '../confirm-redeem/confirm-redeem.component';

@Component({
  selector: 'app-redeem-show',
  templateUrl: './redeem-show.component.html',
  styleUrls: ['./redeem-show.component.less']
})
export class RedeemShowComponent implements OnInit {
  @Input() redeem;
  public redeemObj = {
    refId: '',
    ref_code: '',
    account: '',
    amount: 0,
    bank_name: '',
    date: '',
    email: '',
    full_name: '',
    phone: '',
    status: '',
    user_id: ''
  };

  constructor(private ngbModal: NgbModal, private ngbActiveModal: NgbActiveModal) { }

  ngOnInit() {
    this.setUpredeemObj();
  }

  // sets up redeem object for view purpose
  private setUpredeemObj() {
    this.redeemObj.account = this.redeem.data.account;
    this.redeemObj.amount = this.redeem.data.amount;
    this.redeemObj.bank_name = this.redeem.data.bank_name;
    this.redeemObj.date = this.redeem.data.date;
    this.redeemObj.email = this.redeem.data.email;
    this.redeemObj.full_name = this.redeem.data.full_name;
    this.redeemObj.phone = this.redeem.data.phone;
    this.redeemObj.refId = this.redeem.data.redeem_id;
    this.redeemObj.status = this.redeem.data.status;
    this.redeemObj.ref_code = this.redeem.data.refCode;
    this.redeemObj.user_id = this.redeem.data.user_id;
  }

  // open confirm redeeem modal
  public openMadePaymentModal() {
    const redeemConf = this.ngbModal.open(ConfirmRedeemComponent, {
      size: 'lg'
    });

    redeemConf.componentInstance.data = this.redeem;

    redeemConf.result
      .then((msg) => {
        this.ngbActiveModal.close({ task: 'close modal', success: true });
      })
      .catch((err) => {
        console.log(err);
      });
  }

}
